import { token } from '@atlaskit/tokens';
import { type CSSProperties } from 'react';

import { type PinnedLeadingFieldLayoutItem } from './compute-pinned-leading-layout';

export function getPinnedLeadingCellStyle(
  pinnedLeadingLayout: PinnedLeadingFieldLayoutItem | undefined
): CSSProperties | undefined {
  if (!pinnedLeadingLayout?.isPinned) {
    return undefined;
  }

  return {
    position: 'sticky',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage -- Sticky offset is calculated from column widths.
    left: pinnedLeadingLayout.stickyLeftPx,
    zIndex: pinnedLeadingLayout.bodyZIndex,
    backgroundColor: token('elevation.surface', '#FFFFFF'),
    borderRight: pinnedLeadingLayout.isFreezeBoundary
      ? `${token('border.width', '1px')} solid ${token('color.border', '#091E4224')}`
      : undefined
  };
}
